import { render, staticRenderFns } from "./template_release_config.vue?vue&type=template&id=9a0e4492&scoped=true"
import script from "./template_release_config.vue?vue&type=script&lang=js"
export * from "./template_release_config.vue?vue&type=script&lang=js"
import style0 from "./template_release_config.vue?vue&type=style&index=0&id=9a0e4492&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a0e4492",
  null
  
)

export default component.exports